import React, { useState, useRef, useEffect } from "react";
import "./App.css";

import IconButton from "@mui/material/IconButton";
import Slider from "@mui/material/Slider";
import { Box } from "@mui/system";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import { Midi } from "@tonejs/midi";
import * as Tone from "tone";

// import pianoSong from "https://raw.githubusercontent.com/DarrenKey/testsa/main/piano.wav";
import bassSong from "./test/bass.wav";
import ambianceSong from "./test/ambiance.wav";
import drumsSong from "./test/drums.wav";

import { click } from "@testing-library/user-event/dist/click";
import { duration } from "@mui/material";
import { CollectionsOutlined } from "@mui/icons-material";

function MusicPortion({ value, idName, defaultValue, onChange, fft, player }) {
  return (
    <div id={idName} class="track">
      <div class="tracktitle">{value}</div>

      <Box class="volumeslider">
        <Slider
          value={defaultValue}
          aria-label="Volume"
          valueLabelDisplay="auto"
          color="primary"
          onChange={onChange}
          step={0.05}
          marks
          min={-25}
          max={25}
        />
      </Box>

      <div class="visualizer">
        <AudioVisualizer fft={fft} player={player} />
      </div>
    </div>
  );
}
const AudioVisualizer = (props) => {
  const { fft, player } = props;

  console.log(fft);
  const canvasRef = useRef(null);

  const draw = () => {
    // console.log("should redraw");

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const data = fft.getValue().slice(0, 32);

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // console.log(data);
    for (let i = 0; i < data.length; i++) {
      const x = i * (canvas.width / data.length);
      const y = (data[i] / -100) * canvas.height;

      ctx.fillStyle = "white";
      ctx.fillRect(x, y, canvas.width / data.length, canvas.height);
    }
    requestAnimationFrame(draw);
  };
  useEffect(() => {
    console.log("should happen  ");
    draw();
  }, []);

  return <canvas ref={canvasRef} width={1000} height={175} />;
};

function App() {
  // const piano = new Tone.PolySynth({}, Tone.Synth).toDestination();

  const [clicked, setClicked] = useState(false);

  const [pianoVol, setPianoVol] = useState(5);
  const [drumsVol, setDrumsVol] = useState(-5);
  const [bassVol, setBassVol] = useState(-10);
  const [ambianceVol, setAmbianceVol] = useState(-15);

  const pianoFFT = useRef(new Tone.FFT(64));
  const drumsFFT = useRef(new Tone.FFT(64));
  const bassFFT = useRef(new Tone.FFT(64));
  const ambianceFFT = useRef(new Tone.FFT(64));

  const createPlayer = (vol) => {
    const player = new Tone.Player().toDestination();
    player.loop = true;
    player.autostart = false

    return player;
  };

  const pianoPlayer = useRef(createPlayer(pianoVol));
  const drumsPlayer = useRef(createPlayer(drumsVol));
  const bassPlayer = useRef(createPlayer(bassVol));
  const ambiancePlayer = useRef(createPlayer(ambianceVol));

  pianoPlayer.current.connect(pianoFFT.current);
  drumsPlayer.current.connect(drumsFFT.current);
  bassPlayer.current.connect(bassFFT.current);
  ambiancePlayer.current.connect(ambianceFFT.current);

  useEffect(() => {
    pianoPlayer.current.sync().start(0);
    drumsPlayer.current.sync().start(0);
    bassPlayer.current.sync().start(0);
    ambiancePlayer.current.sync().start(0);
  }, []);

  pianoPlayer.current.volume.value = pianoVol;
  drumsPlayer.current.volume.value = drumsVol;
  bassPlayer.current.volume.value = bassVol;
  ambiancePlayer.current.volume.value = ambianceVol;

  // piano.volume.value = pianoVol;

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
  }

  const start_player = async () => {

    const random_piano_file = require("./generated_piano/" + getRandomInt(1, 321) + '.wav');


    await pianoPlayer.current.load(random_piano_file);
    await drumsPlayer.current.load(drumsSong);
    await bassPlayer.current.load(bassSong);
    await ambiancePlayer.current.load(ambianceSong);


    if (Tone.context.state !== 'running') {
      Tone.context.resume();
    }
    
    Tone.Transport.start();


  }

  const handleIconClick = (id) => {
    setClicked(!clicked);

    // if (Tone.Transport.state == "started") {
    //   Tone.Transport.stop();
    // }

    if (!clicked) {
      console.log("Should start");

      start_player()

      console.log("Should started");

      console.log(pianoPlayer)
    } else {
      Tone.Transport.stop();
    }
  };

  return (
    <div class="app">
      <div class="title">
        ai <br /> lofi
      </div>

      <MusicPortion
        value="piano"
        idName="piano"
        defaultValue={pianoVol}
        onChange={(event, newValue) => {
          setPianoVol(newValue);
          pianoPlayer.current.volume.value = newValue;
        }}
        fft={pianoFFT.current}
        player={pianoPlayer.current}
      />
      <MusicPortion
        value="drums"
        idName="drums"
        defaultValue={drumsVol}
        onChange={(event, newValue) => {
          setDrumsVol(newValue);
          drumsPlayer.current.volume.value = newValue;
        }}
        fft={drumsFFT.current}
        player={drumsPlayer.current}
      />
      <MusicPortion
        value="bass"
        idName="bass"
        defaultValue={bassVol}
        onChange={(event, newValue) => {
          setBassVol(newValue);
          bassPlayer.current.volume.value = newValue;
        }}
        fft={bassFFT.current}
        player={bassPlayer.current}
      />
      <MusicPortion
        value="ambiance"
        idName="ambiance"
        defaultValue={ambianceVol}
        onChange={(event, newValue) => {
          setAmbianceVol(newValue);
          ambiancePlayer.current.volume.value = newValue;
        }}
        fft={ambianceFFT.current}
        player={ambiancePlayer.current}
      />

      <IconButton
        size="large"
        class="playbutton"
        onClick={handleIconClick}
        disableRipple
      >
        {clicked ? (
          <PauseIcon fontSize="inherit" />
        ) : (
          <PlayArrowIcon fontSize="inherit" />
        )}
      </IconButton>
    </div>
  );
}

export default App;
